export const Svg_134 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M32.812 13.854V2.916h4.375v10.938h-4.375Zm18.667 7.729-3.063-3.063 7.73-7.802 3.062 3.136-7.73 7.729Zm4.666 15.604v-4.375h10.938v4.375H56.145ZM32.812 67.083V56.145h4.375v10.938h-4.375ZM18.448 21.51l-7.657-7.656 3.063-3.063 7.729 7.73-3.135 2.989Zm37.77 37.698-7.802-7.73 2.99-2.989 7.875 7.584-3.063 3.135ZM2.916 37.188v-4.376h10.938v4.375H2.916Zm11.01 22.02-3.135-3.063 7.657-7.656 1.604 1.459 1.604 1.53-7.73 7.73ZM35 52.5c-4.861 0-8.994-1.702-12.396-5.105C19.2 43.993 17.5 39.861 17.5 35s1.701-8.994 5.104-12.396C26.006 19.2 30.139 17.5 35 17.5c4.86 0 8.993 1.701 12.395 5.104C50.798 26.006 52.5 30.139 52.5 35c0 4.86-1.702 8.993-5.105 12.395C43.993 50.798 39.861 52.5 35 52.5Zm0-4.375c3.645 0 6.744-1.276 9.297-3.828 2.552-2.553 3.828-5.652 3.828-9.297 0-3.646-1.276-6.745-3.828-9.297-2.553-2.552-5.652-3.828-9.297-3.828-3.646 0-6.745 1.276-9.297 3.828-2.552 2.552-3.828 5.65-3.828 9.297 0 3.645 1.276 6.744 3.828 9.297 2.552 2.552 5.65 3.828 9.297 3.828Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={17.755}
        x2={48.234}
        y1={12.541}
        y2={61.869}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)